import $ from 'jquery';

export default function hideAndShowMobileSearch() {
    var $primaryNavSearchAnchor = $('.primary-nav-search-anchor');

    $primaryNavSearchAnchor.on('click', function() {
        var primaryNavForm = $('.primary-nav-form');

        if (primaryNavForm.css('display') === 'none') {
            // console.debug('show mobile search');
            primaryNavForm.slideDown();
            document.getElementById('mobile-site-search-button').setAttribute('aria-expanded', 'true');
        } else {
            // console.debug('hide mobile search');
            primaryNavForm.slideUp();
            document.getElementById('mobile-site-search-button').setAttribute('aria-expanded', 'false');
        }
    });
}
